window.OperatingHoursAPI = new (function () {
    'use strict';

    const self = this;
    const _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['OperatingHours']);

    self.getOperatingHours = function (brandId) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings`, 'GET')
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
               defer.reject(err);
            });

        return defer.promise;
    };

    self.getBrandOperatingHoursSettings = function (brandId) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings/operating_hours`, 'GET')
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.createOperatingHoursRule = function (brandId, payload) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings/operating_hours`, 'POST', payload)
            .then((res) => {
                if (res && res.data && res.data.data && [200, 201].includes(res.status)) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.updateOperatingHoursRule = function (brandId, ruleId, payload) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings/operating_hours/${ruleId}`, 'PUT', payload)
            .then((res) => {
                if (res && res.data && res.data.data && [200, 201].includes(res.status)) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.deleteOperatingHoursRule = function (brandId, ruleId) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        if (!ruleId) {
            throw "ruleId is required";
        }

        _protected.request(`brands/${brandId}/settings/operating_hours/${ruleId}`, 'DELETE')
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getBrandClosedDaysSettings = function (brandId) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings/closed_days`, 'GET')
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.updateBrandClosedDaysSettings = function (brandId, payload) {
        const defer = $q.defer();

        if (!brandId) {
            throw "brandId is required";
        }

        _protected.request(`brands/${brandId}/settings/closed_days`, 'PUT', payload)
            .then((res) => {
                if (res && res.data && res.data.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            }).catch((err) => {
            defer.reject(err);
        });

        return defer.promise;
    };

    self.getBrandOperatingRevenueHoursSettings = async (brandId) => {
        if (!brandId) {
            throw "brandId is required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/operating_revenue_hours`, 'GET');

        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }

        throw res;
    };

    self.createOperatingRevenueHoursRule = async (brandId, payload) => {
        if (!brandId) {
            throw "brandId is required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/operating_revenue_hours`, 'POST', payload);
        
        if (res?.data?.data && [200, 201].includes(res.status)) {
            return res.data.data;
        }

        throw res;
    };

    self.updateOperatingRevenueHoursRule = async (brandId, ruleId, payload) => {
        if (!brandId) {
            throw "brandId is required";
        }

        if (!ruleId) {
            throw "ruleId is required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/operating_revenue_hours/${ruleId}`, 'PUT', payload);
        
        if (res?.data?.data && [200, 201].includes(res.status)) {
            return res.data.data;
        }

        throw res;
    };

    self.deleteOperatingRevenueHoursRule = async (brandId, ruleId) => {
        if (!brandId) {
            throw "brandId is required";
        }

        if (!ruleId) {
            throw "ruleId is required";
        }

        const res = await _protected.request(`brands/${brandId}/settings/operating_revenue_hours/${ruleId}`, 'DELETE');
        
        if (res?.data?.data && res.status === 200) {
            return res.data.data;
        }

        throw res;
    };

    
});